import React from 'react';

import { User } from '../../types/User';

export interface AuthContextType {
  user: User | null;
  signin: (cpf: string, senha: string) => Promise<boolean>;
  signout: () => Promise<void>;
}

export const AuthContext = React.createContext<AuthContextType | undefined>(
  undefined,
);
